export default {
	row: {
		marginBottom: 0,
	},
};
